import { graphqlClient } from "@/core/api/graphql/client";
import { notifyBrlCurrencyUpdateError } from "@/core/utilities/notifyBrlCurrencyUpdateError";
import mutationDocument from "./updateContactMutation.graphql";
import type { InputUpdateContactTypeExtension, Mutations, MutationsUpdateContactArgs } from "@/core/api/graphql/types";

export async function updateContact(contact: InputUpdateContactTypeExtension): Promise<void> {
  try {
    await graphqlClient.mutate<Required<Pick<Mutations, "updateContact">>, MutationsUpdateContactArgs>({
      mutation: mutationDocument,
      variables: {
        command: contact,
      },
    });
  } catch (error) {
    notifyBrlCurrencyUpdateError(error, contact.currencyCode);
    throw error;
  }
}
